export const skills = [
  "Analyzed the needs for different types of applications",
  "Apply the concepts of the object - oriented programming",
  "Apply the principles of quality assurance and testing techniques to the context of software solution development",
  "Design solutions using best practices in software design",
  "Set up a workstation in a distributed environment",
  "Build ergonomic human-machine interfaces",
  "Deploy an application using continuous integration techniques",
  "Develop algorithms for problem solving",
  "Develop applications of different types: service oriented, on software stacks, full stack, multi-platforms (web, mobile, etc.)",
  "Develop applications that exploit various data sources ",
  "Develop components of different types and integrate them.",
  "Manage activities",
  "Integrate an application into a complex ecosystem",
  "Set up and operate an environment of both relational and non-relational data",
  "Write technical documents ",
];

export const skills_fr = [
  "Analyser les besoins pour différents types d’applications",
  "Appliquer les concepts de l’approche de programmation orientée objet",

  "Appliquer les principes de l’assurance qualité et les techniques de test au contexte de développement de solution logicielle",

  "Concevoir une solution en utilisant les meilleures pratiques de conception de logiciels",

  "Configurer une station de travail dans un environnement distribué",

  "Construire des interfaces personnes-machines ergonomiques",

  "Déployer une application en utilisant les techniques d’intégration continue",

  "Développer des algorithmes pour la résolution de problèmes",

  "Développer des applications de différents types : orientées services, sur des piles de logiciels, full stack, multiplateformes (Web, mobile, etc.)",
  "Développer des applications qui exploitent diverses sources de données",

  "Développer des composantes de différents types et les intégrer",

  "Gérer des activités",

  "Intégrer une application dans un écosystème complexe",

  "Mettre en place et exploiter un environnement de données aussi bien relationnelles que non relationnelles",

  "Rédiger des documents techniques",
];
